
import moment from "moment-timezone";
import React from "react";
import { Link } from "react-router-dom";

export function ContestListCard({ baseColor, list }) {
    return (
        <>
            {list && list.length > 0 && (
                list.map((item) =>
                <div className={`card simple-title-task ui-sortable-handle bg-${baseColor}`}>
                    <div className="card-body">
                        <div className="task-header">
                            <div className="">
                                <h4 className={`text-inverse-${baseColor}`}>{item.id}</h4>
                                <h4 className={`text-inverse-${baseColor} text-uppercase`}>{item.title}</h4>
                                <p className={`text-inverse-${baseColor} text-uppercase `}> 
                                {moment(item.date).format('ll')} {moment(item.time).format('hh:mm a')} 
                                </p>
                                <p className={`text-inverse-${baseColor} text-uppercase`}> 
                                {item?.game?.name} - {item?.gameType?.name} 
                                </p>
                                <p className={`text-inverse-${baseColor}`}> 
                                {/* <span>JOINED PLAYERS / TOTAL PLAYERS : </span> */}
                                {item.totalJoinedPlayers}/{item.userCount || item.totalPlayers}
                                </p>
                                <p className={`text-inverse-${baseColor}`}> 
                                {item.user && item.user.name}
                                </p>
                                <Link to={`/contests/view/${item._id}`}
                                    className={`btn btn-outline-white  mb-2 mr-2  btn-block`}>View
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                )
            )}
            {(!list) && (
                <div className="text-muted">No contest Found</div>
            )}
        </> 
    );
}